import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hub-site-detail',
  templateUrl: './site-detail.component.html',
  styleUrls: ['./site-detail.component.scss']
})
export class SiteDetailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
